import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MessageAttachment } from "../../modals/qna/qna.interface";

/**
 * Single client-side entry point for "user submitted an interactive AI message".
 *
 * The widget hands the response shape (whatever it produces) to {@link submit}, which posts to
 * the generic component-submit endpoint. The server returns the updated attachment (with merged
 * state) so the widget can flip into its post-submit UI without a separate refetch.
 *
 * No widget needs to know the URL, payload shape or ChatService.
 */
@Injectable({ providedIn: "root" })
export class ComponentInteractionService {
  constructor(private http: HttpClient) {}

  submit(
    conversationContextId: string,
    messageId: string,
    type: string,
    response: Record<string, any>
  ): Observable<MessageAttachment> {
    const url = `conversations/${conversationContextId}/messages/${messageId}/component-submit`;
    return this.http.post<MessageAttachment>(url, { type, response });
  }
}
